import axios from 'axios';
import Auth from './auth';

export async function request(options) {
  try {
    console.log(`[API] request: ${JSON.stringify(options, null, 2)}`);
    const result = await axios(options);
    const msg = result?.data?.message;
    console.log(`[API] status: ${result?.status}, message: ${msg}`);

    return result;
  } catch (err) {
    const status = err?.response?.status;
    const msg = err?.message ?? err;

    const log = [
      status ? `status: ${status}` : null,
      msg ? `msg: ${msg}` : null
    ]
      .filter((el) => !!el)
      .join(', ');

    console.log(`[API] error ${log}`);
    throw err;
  }
}

export const getHost = () => {
  // local
  if (/:\d{4,}$/.test(window.location.origin)) {
    const r = window.location.origin.split(/:\d{4,}/);
    if (r[0]) {
      return `${r[0]}:9000`;
    }
  }

  // dev
  if (/miraclemobile\.com\.tw/.test(window.location.host)) {
    return 'https://puzzle-cats.miraclemobile.com.tw';
  }

  // pro
  return 'https://meowohana.com';
};


export const getHeaders = () => {
  return {
    'Content-Type': 'application/json',
    // 'Cache-Control': 'no-cache',
    ...(Auth.hasToken() && { Authorization: `Bearer ${Auth.getToken()}` })
  };
};
